import TypeTag from '~/src/common/components/Recipe/TypeTag/TypeTag';
import { Tag } from '~/src/common/components/Tag/Tag';
import colors from '~/src/common/themes/main/colors';
import { GetRecipeByIdOrSlug200 } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import * as S from './layout';

interface Props {
  className?: string;
  recipe: GetRecipeByIdOrSlug200;
}

export const RecipeNameAndTags = (props: Props) => (
  <S.Root className={props.className}>
    <S.Tags>
      {props.recipe.cookTypes.map(tag => (
        <Tag key={tag} bgColor={colors.LIGHT_GREEN} fgColor={colors.PRIMARY}>
          {tag}
        </Tag>
      ))}

      <TypeTag recipeType={props.recipe.recipeType} />
    </S.Tags>

    <S.CatalogItemName>{props.recipe.name}</S.CatalogItemName>
  </S.Root>
);
